<!-- ======== PROJECTS SECTION ======== -->
<section id="projects" class="projects-section">
  <h2>Projects</h2>

  <!-- PROJECT CARD 1 -->
  <a href="https://njvbindia.com/" target="_blank" class="project-card">
    <div class="project-content">
      <div class="project-text">
        <h3>Industrial Website Development</h3>
        <p>
          A modern and responsive industrial company website showcasing services, products, and business capabilities.
        </p>
        <ul>
          <li>Tech Stack: HTML, CSS, JavaScript, React, Node.js</li>
          <li>Features: Service showcase, Product catalog, Inquiry form, Responsive design</li>
        </ul>
      </div>
      <div class="project-image">
        <img
          src="assets/industrial_image.png"
          alt="Restaurant Reservation Platform">
      </div>
    </div>
  </a>


  <!-- PROJECT CARD 2 -->
    <a href="https://njvbindia.com/" target="_blank" class="project-card">

    <div class="project-content">
      <div class="project-text">
        <h3>Hotel Management System</h3>
        <p>
          A complete hotel management web app with room booking, guest management, and billing dashboard.
        </p>
        <ul>
          <li>Tech Stack: Angular, Spring Boot, MongoDB</li>
          <li>Features: Room booking, Billing, Guest records</li>
        </ul>
      </div>
      <div class="project-image">
        <img
          src="https://media.gettyimages.com/id/1203799607/photo/modern-bedroom-in-the-evening.jpg?s=612x612&w=0&k=20&c=1mEZDPJ-7oTMwH9TjUe2KpfNkF_XcjPhavP8Hr3yOSo="
          alt="Hotel Management System">
      </div>
    </div>
  </a>

  <!-- PROJECT CARD 3 -->
  <a href="https://njvbindia.com/" target="_blank" class="project-card">
    <div class="project-content">
      <div class="project-text">
        <h3>Restaurant Reservation Platform</h3>
        <p>
          An online table booking and restaurant management solution with real-time reservations.
        </p>
        <ul>
          <li>Tech Stack: React, Node.js, Express, MySQL</li>
          <li>Features: Menu management, Live booking, Reports</li>
        </ul>
      </div>
      <div class="project-image">
        <img
          src="https://media.istockphoto.com/id/119926339/photo/resort-swimming-pool.jpg?s=612x612&w=0&k=20&c=9QtwJC2boq3GFHaeDsKytF4-CavYKQuy1jBD2IRfYKc="
          alt="Restaurant Reservation Platform">
      </div>
    </div>
  </a>

  <!-- PROJECT CARD 4 -->
  <a href="https://njvbindia.com/" target="_blank" class="project-card">
    <div class="project-content">
      <div class="project-text">
        <h3>Leave Management Portal</h3>
        <p>
          A centralized HR solution for managing employee leave requests, calendars, and approvals.
        </p>
        <ul>
          <li>Tech Stack: Angular, Spring Boot, MongoDB</li>
          <li>Features: Apply leave, Approvals, Calendar tracking</li>
        </ul>
      </div>
      <div class="project-image">
        <img
          src="https://cdn.dribbble.com/userupload/23990812/file/original-e0888b788f1024cf972ed7f499085dc1.jpg?format=webp&resize=640x480&vertical=center"
          alt="Leave Management Portal">
      </div>
    </div>
  </a>

  <!-- PROJECT CARD 5 -->
  <a href="https://njvbindia.com/" target="_blank" class="project-card">
    <div class="project-content">
      <div class="project-text">
        <h3>Online Bus Booking System</h3>
        <p>
          A seamless ticketing and bus management platform with real-time seat availability.
        </p>
        <ul>
          <li>Tech Stack: Angular, Java, Firebase</li>
          <li>Features: Live seat map, Payment system, Trip management</li>
        </ul>
      </div>
      <div class="project-image">
        <img
          src="https://www.99cashdeals.com/blog/wp-content/uploads/2025/01/Build-Your-Own-Online-Bus-Ticket-Booking-Ap.jpg"
          alt="Online Bus Booking System">
      </div>
    </div>
  </a>

  <!-- PROJECT CARD 5 -->
<a href="https://maitreytrading.netlify.app/" target="_blank" class="project-card">
  <div class="project-content">
    <div class="project-text">
      <h3>Solar Energy Management System</h3>
      <p>
        A smart platform to monitor, analyze, and optimize solar power generation and consumption in real time.
      </p>
      <ul>
        <li>Tech Stack: Angular, Java, Spring Boot, MongoDB</li>
        <li>Features: Live energy monitoring, Performance analytics, Maintenance alerts</li>
      </ul>
    </div>
    <div class="project-image">
      <img
        src="https://images.unsplash.com/photo-1508514177221-188b1cf16e9d"
        alt="Solar Energy Management System">
    </div>
  </div>
</a>

</section>